import { create } from "zustand";

export type NotifKind =
  | "broker_adopted"
  | "proposal_created"
  | "proposal_accepted"
  | "proposal_round"
  | "media_broadcast";

export interface AppNotification {
  id: string;
  kind: NotifKind;
  title: string;
  /** Rótulo relativo (ex.: "agora", "há 2h"). */
  at: string;
  read: boolean;
  /** Rota de origem (ex.: "/proposals/p1", "/media/bc1") — clique navega até lá. */
  href?: string;
}

/** Rota de origem padrão por tipo, quando não houver um alvo específico. */
export function defaultHref(kind: NotifKind): string {
  switch (kind) {
    case "broker_adopted":
      return "/brokers";
    case "media_broadcast":
      return "/media";
    default:
      return "/proposals";
  }
}

interface NotificationsState {
  items: AppNotification[];
  /** Lista já carregada do servidor/mock pelo menos uma vez? */
  hydrated: boolean;
  connected: boolean;
  /** Substitui a lista (carga inicial via GET /notifications ou fixtures). */
  setItems: (items: AppNotification[]) => void;
  add: (n: Omit<AppNotification, "read">) => void;
  markRead: (id: string) => void;
  markAllRead: () => void;
  setConnected: (v: boolean) => void;
}

export const useNotificationsStore = create<NotificationsState>((set) => ({
  items: [],
  hydrated: false,
  connected: false,
  setItems: (items) => set({ items, hydrated: true }),
  add: (n) =>
    set((s) => ({ items: [{ ...n, read: false }, ...s.items].slice(0, 50) })),
  markRead: (id) =>
    set((s) => ({ items: s.items.map((i) => (i.id === id ? { ...i, read: true } : i)) })),
  markAllRead: () => set((s) => ({ items: s.items.map((i) => ({ ...i, read: true })) })),
  setConnected: (v) => set({ connected: v }),
}));

export function unreadCount(items: AppNotification[]): number {
  return items.filter((n) => !n.read).length;
}
